import { connect } from "react-redux";
import SideBar from "../../Components/SideBar/SideBar";
const mapStateToProps = (state) => ({
   ROLES: state.reducer.ROLES,
    SCOPES: state.reducer.SCOPES,
    SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});
const mapDispatchToProps = (dispatch) => ({
    
});
 
export default connect(mapStateToProps, mapDispatchToProps)(SideBar);